<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div v-if="!loading && details">

    </div>
  </div>
</template>
<script>

import api from "@/api";

export default {
  props: ['recordId'],
  data() {
    return {
      loading: false,
      details: null,
    }
  },
  created() {
    this.getDrugDetails();
  },
  methods: {
    async getDrugDetails() {
      this.loading = true;
      const {data} = await api.index('/statistics/003/drug/relation/' + this.recordId);
      this.loading = false;
    }
  }
}

</script>
